module.exports = __webpack_public_path__ + "static/media/mainnet-network.895301a4.svg";